// Recovered compiled webpack factory 81725. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { B$: () => f, ur: () => c });
  var n = r(2257),
    a = r(16649),
    o = r(73314),
    i = r(51217),
    s = r(87624),
    l = r(49636),
    u = r(21010);
  function c(e, t) {
    let r = "fetch";
    ((0, u.s5)(r, e), (0, u.AS)(r, () => d(void 0, t)));
  }
  function f(e) {
    let t = "fetch-body-resolved";
    ((0, u.s5)(t, e), (0, u.AS)(t, () => d(h)));
  }
  function d(e, t = !1) {
    (!t || (0, i.m7)()) &&
      (0, o.GS)(l.O, "fetch", function (t) {
        return function (...r) {
          let i = Error(),
            { method: c, url: f } = (function (e) {
              if (0 === e.length) return { method: "GET", url: "" };
              if (2 === e.length) {
                let [t, r] = e;
                return {
                  url: m(t),
                  method: _(r, "method")
                    ? String(r.method).toUpperCase()
                    : (0, a.ks)(t) && _(t, "method")
                      ? String(t.method).toUpperCase()
                      : "GET",
                };
              }
              let t = e[0];
              return { url: m(t), method: _(t, "method") ? String(t.method).toUpperCase() : "GET" };
            })(r),
            d = {
              args: r,
              fetchData: { method: c, url: f },
              startTimestamp: 1e3 * (0, s.zf)(),
              virtualError: i,
              headers: (function (e) {
                let [t, r] = e;
                try {
                  if ("object" == typeof r && null !== r && "headers" in r && r.headers)
                    return new Headers(r.headers);
                  if ((0, a.ks)(t)) return new Headers(t.headers);
                } catch {}
              })(r),
            };
          return (
            e || (0, u.aj)("fetch", { ...d }),
            t.apply(l.O, r).then(
              async (t) => (
                e
                  ? e(t)
                  : (0, u.aj)("fetch", { ...d, endTimestamp: 1e3 * (0, s.zf)(), response: t }),
                t
              ),
              (e) => {
                ((0, u.aj)("fetch", { ...d, endTimestamp: 1e3 * (0, s.zf)(), error: e }),
                  (0, a.bJ)(e) &&
                    void 0 === e.stack &&
                    ((e.stack = i.stack), (0, o.my)(e, "framesToPop", 1)));
                let t = (0, n.KU)(),
                  r = t?.getOptions().enhanceFetchErrorMessages ?? "always";
                if (
                  !1 !== r &&
                  e instanceof TypeError &&
                  ("Failed to fetch" === e.message ||
                    "Load failed" === e.message ||
                    "NetworkError when attempting to fetch resource." === e.message)
                )
                  try {
                    let t = new URL(d.fetchData.url).host;
                    "always" === r
                      ? (e.message = `${e.message} (${t})`)
                      : (0, o.my)(e, "__sentry_fetch_url_host__", t);
                  } catch {}
                throw e;
              },
            )
          );
        };
      });
  }
  async function p(e, t) {
    if (e?.body) {
      let r = e.body,
        n = r.getReader(),
        a = setTimeout(() => {
          r.cancel().then(null, () => {});
        }, 9e4),
        o = !0;
      for (; o; ) {
        let e;
        try {
          e = setTimeout(() => {
            r.cancel().then(null, () => {});
          }, 5e3);
          let { done: a } = await n.read();
          (clearTimeout(e), a && (t(), (o = !1)));
        } catch {
          o = !1;
        } finally {
          clearTimeout(e);
        }
      }
      (clearTimeout(a), n.releaseLock(), r.cancel().then(null, () => {}));
    }
  }
  function h(e) {
    let t;
    try {
      t = e.clone();
    } catch {
      return;
    }
    p(t, () => {
      (0, u.aj)("fetch-body-resolved", { endTimestamp: 1e3 * (0, s.zf)(), response: e });
    });
  }
  function _(e, t) {
    return !!e && "object" == typeof e && !!e[t];
  }
  function m(e) {
    return "string" == typeof e
      ? e
      : e
        ? _(e, "url")
          ? e.url
          : e.toString
            ? e.toString()
            : ""
        : "";
  }
}
